import styled from 'styled-components';

export const ButtonContainerSucesso = styled.div`
    display: flex;
    background-color: '#5B5B5F1A';
    justify-content: flex-end;
    width: 100%;
    gap: 24px;
    

    @media screen and (max-width: 950px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const DivPDF = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .DivPDFDownload {
        display: flex;
        margin-top: 10px;
        cursor: pointer
    }
`;
